export interface PopoverFitInput {
  /** The popover's current bottom edge, in viewport coordinates (px). */
  popoverBottom: number;
  /** The popover's current top offset (px). */
  currentTop: number;
  /** The viewport height (px). */
  viewportHeight: number;
  /**
   * Gap to keep between the popover and the viewport edges (px): the bottom
   * edge it's slid away from, and the top edge it's clamped to.
   */
  margin: number;
}

/**
 * Computes the top offset that keeps a popover whose bottom overflows the
 * viewport fully on screen: slide it up by the overflow, but never past
 * `margin` from the top. Returns null when it already fits and must not move.
 */
export const computePopoverTopToFit = ({
  popoverBottom,
  currentTop,
  viewportHeight,
  margin,
}: PopoverFitInput): number | null => {
  const overflow = popoverBottom - (viewportHeight - margin);
  if (overflow <= 0) return null;
  return Math.max(margin, currentTop - overflow);
};
